import { render } from "./credit-card-icon.svg?vue&type=template&id=c7d261be"
import script from "./credit-card-icon.svg?vue&type=script&lang=js"
export * from "./credit-card-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4146/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__